// Pantalla `command="login-reset-password"`. Port de la rama `when
// "login-reset-password"` de keycloak.coffee. Form simple con email y
// link "llévame de nuevo a la página de inicio". El link de vuelta usa
// getFinalURL para preservar nativeApp.

import type { FormEvent } from "react";
import type { KcData } from "../kcData";
import { Input } from "../components/Input";
import { StandardPage } from "../components/StandardPage";
import { getFinalURL } from "../nativeApp";
import { msg } from "../i18n";

export interface LoginResetPasswordPageProps {
  data: KcData;
  running: boolean;
  nativeApp: string | null;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

export function LoginResetPasswordPage(props: LoginResetPasswordPageProps) {
  const { data, running, nativeApp, onSubmit } = props;
  const url = data.url!;
  const formEmail = (data.form?.email as string | undefined) ?? "";

  return (
    <StandardPage page="login-reset-password" data={data}>
      <div>
        <div className="forgot-text">{msg("emailForgotText")}</div>
        <form
          id="kc-reset-password-form"
          action={url.loginAction}
          method="post"
          onSubmit={onSubmit}
        >
          <Input
            type="email"
            id="username"
            name="username"
            autoFocus
            defaultValue={formEmail}
            placeholder={msg("emailResetPlaceholder")}
            messagesPerField={data.messagesPerField}
          />
          <button
            type="submit"
            className="btn btn-lg btn-block btn-primary"
            disabled={running}
          >
            {msg("doSubmitForgotPassword")}
          </button>
          <div className="text-back">
            <span>
              {msg("backToLoginForgotPassword")}
              <a href={getFinalURL(url.loginUrl, nativeApp)}>
                {msg("backToLoginForgotPasswordUrl")}
              </a>
            </span>
          </div>
        </form>
      </div>
    </StandardPage>
  );
}
